import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertIcon } from "../lib/icons.js";
import { getFtpStatus } from "../lib/ftpAdminApi.js";

/**
 * Global pending-files indicator — zobrazí se v headeru, pokud na FTP
 * čekají nové/neklasifikované soubory. Kliknutím naviguje na admin.
 *
 * Poll každých 60 s. Nikdy nespustí syncing.
 */
export function FtpPendingBanner(): JSX.Element | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    async function load(): Promise<void> {
      try {
        const s = await getFtpStatus();
        if (!cancelled) setCount(s.pendingFilesCount);
      } catch {
        // ignore — admin route nevyžaduje critical feedback
      }
    }
    void load();
    const iv = setInterval(load, 60_000);
    return () => {
      cancelled = true;
      clearInterval(iv);
    };
  }, []);

  if (!count || count === 0) return null;

  return (
    <Link
      to="/admin/ftp"
      className="hidden md:inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md bg-amber-500/15 hover:bg-amber-500/25 text-amber-200 text-xs font-medium transition-colors whitespace-nowrap"
      title={`${count} ${count === 1 ? "nový soubor" : count < 5 ? "nové soubory" : "nových souborů"} na FTP čeká na kontrolu`}
    >
      <AlertIcon size={14} />
      <span className="font-semibold tabular-nums">{count}</span>
      <span className="text-amber-200/80">FTP</span>
    </Link>
  );
}
